export const RootUrl = 'https://tatooine.2hire.io';
export const BaseUrl = '/v4/admin';

export const MapBox = {
  Style: 'styles/mapbox/streets-v11',
  BaseUrl: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11',
  accessToken: 'pk.eyJ1IjoiMmhpcmUiLCJhIjoiY2tvYm90d2h1MWc3bzJ2bXEzZndiMGVhNSJ9.RJBxPuaLliGvEtiVSGWD8Q',
};
